import workspaceQuery from '../../../graphql/queries/sales/SalesOrderDeliveryAddressWorkspaceQuery.graphql';
import { ALLOW_ADD, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const SalesOrderDeliveryAddress: EntityType = {
  type: 'SalesOrderDeliveryAddress',
  title: 'Sales Order Delivery Addresses',
  workspaceUrl: '/Sales/DeliveryAddress/Workspace/',
  workspace: workspaceQuery,
  screenReference: 'SALES_ORDER_DELIVERY_ADDRESS',
  operations: ALLOW_ADD | ALLOW_EDIT | ALLOW_VIEW,
};

export default SalesOrderDeliveryAddress;
